const timeouts = new Map()

const getDropdownElement = (name = '') => {
  return document.querySelector(`.dropdown[data-dropdown="${name}"]`)
}

document.querySelectorAll('[data-dropdown]').forEach((dropTrigger) => {
  const name = dropTrigger.dataset.dropdown
  const container = getDropdownElement(name)
  if (container) {
    dropTrigger.addEventListener('mouseenter', () => {
      clearTimeout(timeouts[container])
      document
        .querySelectorAll('.dropdown')
        .forEach((dropdown) => dropdown.classList.remove('is-open'))
      container.classList.add('is-open')
      dropTrigger.classList.add('is-active')
      document.documentElement.classList.add('is-dropdown-open')
    })
    dropTrigger.addEventListener('mouseleave', () => {
      dropTrigger.classList.remove('is-active')
      timeouts[container] = setTimeout(() => {
        container.classList.remove('is-open')
        document.documentElement.classList.remove('is-dropdown-open')
      }, 1000)
    })

    container.addEventListener('mouseenter', () => {
      dropTrigger.classList.add('is-active')
      clearTimeout(timeouts[container])
    })
    container.addEventListener('mouseleave', () => {
      container.classList.remove('is-open')
      dropTrigger.classList.remove('is-active')
      document.documentElement.classList.remove('is-dropdown-open')
    })
  } else {
    console.warn(`Dropdown element not found for name: ${name}`)
  }
})
